export const TEMPLATE_GENERATION_PREREQUISITES = {
  VEHICLES: {
    LASSIE: ['LPV_none', 'LTV_none'],
  },
  LOAD_CARRIERS: {
    LASSIE: ['TOTE_ID'],
  },
} as const;

// TODO before end of MVP: test + tweak to achieve estimated good bounds
export const LASSIE_MINI_BOUNDS = {
  MIN: {
    NUM_AISLES: 1,
    NUM_BAYS: 1,
    NUM_SHELVES: 2,
  },
  MAX: {
    NUM_AISLES: 30,
    NUM_BAYS: 20,
    NUM_SHELVES: 21,
  },
} as const;

export const LASSIE_BOUNDS = {
  MIN: {
    NUM_AISLES: 1,
    NUM_BAYS: 1,
    NUM_SHELVES: 1,
  },
} as const;

export const SHUTTLE_RACK = {
  MIN: {
    NUM_COLUMNS: 1,
    NUM_LEVELS: 1,
    NUM_DEEP: 1,
  },
} as const;
